import React from "react";
import CircularProgressBar, {
  CircularProgressSize,
} from "../CircularProgressBar/CircularProgressBar";

const ButtonGroupFooter = ({
  handleLeftButtonClick,
  isLoading = false,
  handleRightButtonClick,
  leftButtonText = "Go Back",
  leftButtonType = "button",
  rightButtonType = "submit",
  rightButtonText = "Submit",
}) => {
  return (
    <div className="btn-sec position-fixed bottom-0 mt-3">
      {isLoading ? (
        <CircularProgressBar size={CircularProgressSize.large} />
      ) : (
        <>
          <button
            className="Goback_btn"
            type={leftButtonType}
            onClick={handleLeftButtonClick}
          >
            {leftButtonText}
          </button>
          <button
            className="submitBtn"
            type={rightButtonType}
            disabled={isLoading}
            onClick={handleRightButtonClick}
          >
            {rightButtonText}
          </button>
        </>
      )}
    </div>
  );
};

export default ButtonGroupFooter;
